import React, { useEffect } from 'react';
import { InputField, LoadingSpinner } from '@repo/ui/components';
import { cn, formatNumberInput, InputType, TAdornmentProps } from 'types';

export interface IFormRow {
  id: string;
  isEditable: boolean;
  isValid: boolean;
  collapsedWarning?: boolean;
  label: string | React.ReactNode;
  maxLength?: number;
  placeholder?: string;
  type?: InputType;
  validationMessage?: string;
  disabled?: boolean;

  startAdornment?: TAdornmentProps;
  endAdornment?: TAdornmentProps;
  value?: any;
  defaultValue?: any;
  valuePostfix?: string;
  valueLoading?: boolean;
  className?: string;
  valueClassName?: string;
  isUsedCar?: boolean;
  errorVariant?: 'text' | 'messageBar';

  decimals?: 0 | 2 | 1 | 3 | 4;
  onChange?(value): void;
  onSubmit?(value): void;
  onBlur?(value): void;
}

export const getDisplayValue = (props: IFormRow) => {
  return typeof props.value === 'number' || typeof props.defaultValue === 'number'
    ? props.value || props.defaultValue || '0'
    : props.value || props.defaultValue || '';
};

export const FormRow = (props: IFormRow) => {
  const [displayValue, setDisplayValue] = React.useState(getDisplayValue(props));

  const validationMessage =
    props.validationMessage && !(props.collapsedWarning && props.isValid)
      ? props.validationMessage || 'Obligatorisk'
      : null;

  useEffect(() => {
    setDisplayValue(getDisplayValue(props));
  }, [props.value, props.defaultValue]);

  return (
    <div className={cn('flex justify-between w-full gap-4', props.className)}>
      {!props.isEditable && (
        <label className={cn('text-base/[175%] font-semibold flex-1 empty:hidden')}>{props.label}</label>
      )}
      {props.isEditable ? (
        <div className="flex flex-col gap-1 w-full">
          <label className={cn('text-base/[175%] font-semibold flex-1 empty:hidden')}>{props.label}</label>
          <InputField
            className={cn('w-full', props.startAdornment && 'pl-11')}
            defaultValue={props.defaultValue?.toString()}
            value={props.value?.toString()}
            id={props.id}
            maxLength={props.maxLength}
            onChange={props.onChange}
            onBlur={props.onBlur}
            onSubmit={props.onSubmit}
            isValid={props.isValid}
            hideValidationIcon={props.disabled}
            errorMessage={validationMessage}
            startAdornment={props.startAdornment}
            endAdornment={!props.disabled && props.value && props.endAdornment}
            placeholder={props.placeholder}
            type={props.type || InputType.TEXT_LINE}
            decimals={props.decimals}
            disabled={props.disabled}
            errorVariant={props?.errorVariant || 'messageBar'}
          />
        </div>
      ) : props?.valueLoading ? (
        <LoadingSpinner size={24} />
      ) : (
        <p className={cn('text-base/[175%] font-semibold mb-1', props.valueClassName)}>
          {`${
            typeof displayValue === 'number'
              ? formatNumberInput(displayValue.toString(), props?.type).formatted
              : displayValue
          }${props.valuePostfix}`}
        </p>
      )}
    </div>
  );
};
